export const dataCityWatter = {
    backgroundImage: '/assets/imgs/services/1BuildingEnvelopeRenewals/featuregridSection/fondo.png'
};
